import React, {FC} from "react"

import StyledAnchor, {AnchorProps} from "./styled/Anchor"
import {SpacingProps} from "../global/css"

export interface Props extends AnchorProps, SpacingProps {}

const Link: FC<Props> = (props) => {
  return <StyledAnchor {...props}>{props.children}</StyledAnchor>
}

export {default as RouterLink} from "./RouterLink"

export {default as ButtonLink} from "./ButtonLink"
export {default as ButtonRouterLink} from "./ButtonLink/ButtonRouterLink"
export {default as IconButtonRouterLink} from "./ButtonLink/IconButtonRouterLink"
export {default as ValidationButtonRouterLink} from "./ButtonLink/ValidationButtonRouterLink"

export default Link
